<form [formGroup]="form">
  <mat-form-field appearance="outline" [hideRequiredMarker]="true">
    <mat-label>Kod weryfikacyjny</mat-label>
    <input
      matInput
      type="text"
      inputmode="numeric"
      placeholder="XXX-XXX"
      [formControl]="form.code"
      (input)="errors = []"
      mask="000-000"
      (keydown.enter)="onSubmit()"
      pattern="\d{6}"
      appGtmFormEvent
      [eventField]="'code'"
      [eventForm]="formName"
    />

    <mat-error
      *ngIf="
            form.code.invalid &&
            (form.code.dirty || !form.code.untouched)">
      <span *ngIf="form.code.errors.required">Wpisz kod weryfikacyjny</span>
      <span *ngIf="form.code.errors.minlength">Kod musi składać się z 6 cyfr</span>
    </mat-error>
    <mat-error *ngFor="let error of errors">
      {{ errorMessages[error] }}
    </mat-error>
  </mat-form-field>

  <div class="actions">
    <app-new-loader-button
      role="button"
      (buttonClick)="onSubmit()"
      [disabled]="loading || (submitted && !form.valid)"
      [loading]="loading"
      class="auth-button"
      id="register-button"
      [customType]="LoaderButtonType.RAISED"
      color="accent">
      Dalej
    </app-new-loader-button>
  </div>
  <footer class="footer"
          fxLayout="column" fxLayoutAlign="start center">
    <p>
      Nie otrzymałeś e-maila?
      <button type="button" *ngIf="!sentCode" (click)="onSendCodeClick()" class="inline-button">Wyślij kod ponownie
      </button>
      <span *ngIf="sentCode" class="inline-button">Wysłano kod ponownie</span>
    </p>
    <br>
    <button type="button" class="back-button" (click)="onGoBackClick()" mat-button>Wróć</button>
  </footer>
</form>
